import * as React from 'react';
import * as main from "../../main.module.scss";
import * as details from "./style.module.scss";
export const Details = () => {
  return (
    <section className={details.detailes}>
      <div className="container">
        <div className={details.block}>
          <h2 className={main.title}>Подробно разберем:</h2>
          <ul>
            <li>
              <div className={details.pseudo}>
                <div className={details.pseudoTriangle}></div>
              </div>
              <div className={details.text}>
                <h4>Алгоритм занятия математикой</h4>
                <p>(таблица умножения, состав числа, быстрый устный счёт)</p>
              </div>
            </li>
            <li>
              <div className={details.pseudo}>
                <div className={details.pseudoTriangle}></div>
              </div>
              <div className={details.text}>
                <h4>Чтение</h4>
                <p>(скорость чтения, от чего она зависит)</p>
              </div>
            </li>
            <li>
              <div className={details.pseudo}>
                <div className={details.pseudoTriangle}></div>
              </div>
              <div className={details.text}>
                <h4>Иностранный язык</h4>
                <p>(запоминание слов на практике)</p>
              </div>
            </li>
            <li>
              <div className={details.pseudo}>
                <div className={details.pseudoTriangle}></div>
              </div>
              <div className={details.text}>
                <p>Поговорим о том, как помочь ребёнку стать самостоятельнее и выполнять домашнее задание без помощи родителей</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
